'use client';

import { Skeleton, Stack, Typography } from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { Contact } from "@/app/lib/generated/graphql-types";
import Link from "next/link";

export default function FooterContactViewMobile({ contact }: { contact: Contact}) {
    return (
        <Stack component={Link} href="/contact" prefetch aria-label="Kontakt" spacing={4} direction="row" sx={{ width: '100%', alignItems: 'center' }}>
            <LocationOn />
            <Stack spacing={0} direction="column" sx={{ alignItems: 'flex-start', flexGrow: 1}}>
                <Typography variant="body2" fontWeight="bold">
                    {contact.address.street}
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                    {`${contact.address.zipCode} ${contact!.address.city}`}
                </Typography>
            </Stack>
        </Stack>
    )
}

export const FooterContactViewMobileSkeleton = () => {
    return (
        <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
            <LocationOn />
            <Skeleton variant="text" width={200}>
                <Typography variant="body2" fontWeight="bold" width="100%">Street</Typography>
                <Typography variant="body2" fontWeight="bold" width="100%">ZipCode City</Typography>
            </Skeleton>
        </Stack>
    )
}